module.exports = {
  email: {
    type: 'text',
    placeholder: 'form.fields.email',
    validation: [
      { type: 'required' },
      { type: 'email' },
      { type: 'email-with-local-part-not-bigger-than-25' },
    ],
  },
  message: {
    type: 'textarea',
    placeholder: 'form.fields.message',
    validation: [
      { type: 'required' },
    ],
  },
};
